﻿export default {
  "rounds": 1,
  "seed": "e520f2f34adb4aae65b839bc0d9e45707bbccd3a381a1aad961a39ca5001fe6d3a4140e80a6e14dee065048fe750a0f6fca2c3b45965f17932fe642a232fb2bb"
};